import type { UserInfo } from "./AuthContext";

/**
 * Shape of the JSON payload written to `sessionStorage` to drive the
 * dev/e2e mock auth flow consumed by `MideyeAppAuthProvider`.
 *
 * `availableCompanies` is consumed by e2e fixtures to seed the
 * `/api/v1/companies` route mock; the lib itself only reads `user`/`token`.
 */
export interface MockAuthState {
  user: UserInfo;
  availableCompanies?: string[];
  token?: string;
}

export const MOCK_AUTH_STORAGE_KEY = "__mock_auth_state__";

